"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKENS = exports.TEXT_TYPE = exports.ARR_COLUMN_SPAN = void 0;
var TOKENS = {
  DEFAULT_IMAGE_WIDTH: '100%',
  DEFAULT_IMAGE_HEIGHT: '100%',
  TAG: {
    TEXT_COLOR: 'default',
    LABEL_COLOR: 'turquoise'
  },
  TEXT: {
    DEFAULT: 'default',
    SUB: 'sub',
    SMALL: 'small'
  },
  TITLE: {
    SIZE: 'h3'
  },
  DESCRIPTION: {
    SIZE: {
      DESKTOP: 'default',
      MOBILE: 'sub'
    },
    COLOR: 'greyDarker'
  },
  FIND: {
    TITLE: 'Find out more',
    SIZE: 'sub',
    COLOR: 'orangeDarkMedium'
  }
};
exports.TOKENS = TOKENS;
var TEXT_TYPE = {
  default: {
    type: 'default',
    size: 'normal',
    lineHeight: 'normal'
  },
  sub: {
    type: 'sub',
    size: 'small',
    lineHeight: 'large'
  },
  small: {
    type: 'small',
    size: 'XSmall',
    lineHeight: 'small'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var ARR_COLUMN_SPAN = ['2', '3', '4', '1'];
exports.ARR_COLUMN_SPAN = ARR_COLUMN_SPAN;